<template>
    <div>
        <v-row>
            <ImportButton
                :items="importOptions"
                context="InventoriesImport"
                :alvqa="alvqa"
            />
            <div class="d-flex align-center" style="margin-top: 10px; margin-left: -8px;">
                <ContextHelpIcon 
                    v-if="hasContextHelp"
                    context="ErpInventoriesImport"
                    :alvqa="alvqa + '-list-import-context-help-icon'"
                />
            </div>
            <v-col 
                cols="4"
                v-if="totalRecords !== null"
                align-self="center"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats context="Inventories" typeStats="LIST" alvqa="erp-inventories-list" />
            </v-col>
            <v-spacer /> 
            <v-col 
                cols="2"
                align-self="center"
            >
                <v-tooltip bottom color="tooltipBackground" :disabled="getInventoriesExportEnabled">
                    <template v-slot:activator="{ on }">
                        <div v-on="on">
                            <BaseButton 
                                label="lang_GENERIC_CAPTION_EXPORT"
                                block
                                icon="library_books"
                                :disabled="!getInventoriesExportEnabled"
                                @click="exportInventories()"
                                :alvqa="alvqa + '-list-button-export-all'"
                            />
                        </div>
                    </template>
                    <span>{{ $t('lang_ERP_INVENTORIES_MESSAGE_SELECT_DATE_AND_SEARCH') }}</span>
                </v-tooltip>

            </v-col>
            <v-col 
                cols="2"
                align-self="center"
            >
                <BaseButton 
                    label="lang_LABEL_RELEASES_CAPTION_MINIMUM_STOCK"
                    @click="minStockReport()"
                    block
                    :alvqa="alvqa + '-list-minimum-stock-button'"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ImportButton from '@/components/_buttons/ImportButton'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon'

export default {
    name: "InventoriesTopSlot",
    components: {
        ImportButton,
        BaseHeaderStats,
        BaseButton,
        ContextHelpIcon
    },
    data() {
        return {
            context: "Inventories",
            alvqa: "erp-inventories",
            hasContextHelp: false
        }
    },
    computed: {
        totalRecords() { return this.$store.getters.getTotalRecords },
        getInventoriesExportEnabled() { return this.$store.getters.getInventoriesExportEnabled },
        importOptions() {
            let options = JSON.parse(JSON.stringify(this.$store.getters.getInventoriesWarehousesOptions))
            let items = []

            options.forEach(option => {
                let item = {
                    'alvqa': this.alvqa + '-list-import-dropdown-' + option.alvId,
                    'text': option.gemaName + ' ('+ option.alvId +')',
                    'value': option.alvId
                }
                items.push(item)
            })
            
            return items
        }
    },
    methods:{
        minStockReport(){
            this.$store.dispatch('createMinStockReport')
        },
        exportInventories(){
            this.$store.dispatch('exportAllInventories')
        }
    },
    async created() {
        this.hasContextHelp = await this.$alvPlugin.checkContextHelpAvailability('ErpInventoriesImport')
    }
}
</script>